export default {
  bad_connection: '연결상태가 불안정합니다. 네트워크 연결상태를 확인하시고 다시 시도해 주세요.',
  send: '전송',
  select_hotel: '투숙하시는 호텔을 선택해 주세요. ',
  select_language: '언어를 선택하십시오.',
  start_chatting: '채팅시작',
  languages: '언어',
  menu: '메뉴',
  close: '닫기',
  back: '돌아가기',
  next: '다음',
  message: '질문을 문장으로 입력',
  search: '검색',
  select: '선택',
  sign_in: '로그인',
  sign_out: '로그아웃',
  sign_up: '가입하기',
  smoking: '흡연',
  no_smoking: '금연',
  adults: '성인',
  xAdults: '성인',
  children: '어린이',
  ageOfChild: '어린이 연령',
  seeAll: '전체보기',
  email: '이메일',
  email_confirmation: '이메일 (재확인)',
  phone_number: '전화번호',
  icc: 'ICC',
  month: '월',
  year: '년',
  including_taxes: '세금포함',
  excluding_taxes: '세금제외',
  show_more: '더보기',
  show_less: '접기',
  file_upload: {
    unsupported_file_type: '죄송합니다. {file_type} 형식의 파일은 지원하지 않습니다.',
    file_size_exceeded: '파일크기가 10MB를 초과했습니다.',
    file_upload_failed: '파일 업로드에 실패했습니다.',
    max_files_upload_simultaneously: '한 번에 최대 5개의 파일을 업로드 하실 수 있습니다.'
  },
  base: {
    back_to_list: '목록으로 돌아가기',
    pay: '지불',
    cancel: '취소',
    delete: '삭제',
    yes: '네',
    no: '아니요',
    book: '예약',
    direct_price: '직판가',
    membership_rate: '멤버십요금',
    regular_rate: '일반요금',
    expand_for_price: '비교하려면 확장',
    confirmSelection: '선택 내용 확인',
    neverAskAgain: '그만 보기',
    accept: '동의함',
    do_not_accept: '동의하지 않음',
    password: '비밀번호',
    email: '이메일',
    save: '저장',
    confirm_password: '비밀번호 확인',
    error02: '죄송합니다. 처리중 에러가 발생했습니다. 잠시 후 다시 시도해 주시기 바랍니다.',
    errorCode: {
      3001: '시간 초과 에러가 발생했습니다. 결제 처리는 진행되지 않았습니다.',
      3002: '결제 처리에 실패했습니다.',
      3003: '이 카드는 이용하실 수 없습니다.',
      3004: '카드번호를 확인바랍니다.',
      3005: '만료일이 올바른지 확인하십시오.',
      3006: '3D Secure 인증에 실패했습니다.',
      3007: '이용할 수 없는 카드를 입력했거나 카드번호가 잘못되었습니다.',
      3008: '3D Secure 인증이 취소되었습니다.',
      3009: '중복 요청으로 인해 3D Secure 인증을 중단했습니다.',
      3011: '시간 초과 에러가 발생했습니다. 결제 처리는 진행되지 않았습니다.',
      3203: '죄송합니다. 처리중 에러가 발생했습니다. 잠시 후 다시 시도해 주시기 바랍니다.',
      3204: '결제에 실패했습니다. 다른 카드를 사용하거나 나중에 다시 시도하세요.',
      3205: '이 카드는 이용하실 수 없습니다.'
    }
  },
  triplaPayIssues: {
    INVALID_PARAMETER_SYNTAX: '입력한 정보를 확인하세요.',
    INVALID_EXPIRATION_YEAR: '만료일이 올바른지 확인하십시오.',
    Invalid_card_number: '카드번호를 확인바랍니다.',
    Others: '입력한 정보를 확인하세요.'
  },
  validation: {
    is_required: '{field} is required',
    correct_email: '올바른 이메일주소를 입력해 주세요.',
    invalid_integer: '정수를 입력하십시오.'
  },
  chat_body: {
    deleted_message: '해당 메시지를 삭제했습니다',
    op_deleted_msg: '오퍼레이터가 해당 메시지를 삭제했습니다',
    delete_message: '메시지 삭제',
    delete_message_desc: '해당 메시지를 삭제하시겠습니까?  삭제된 메시지는 복구할 수 없습니다.'
  },
  user_top: {
    information:
      '다른 기기로 계속 채팅을 하고 싶으시다면 가입해주시기 바랍니다. 로그인을 하시면 어느 기기에서든지 메세지 내역을 복구하실 수 있습니다.',
    terms_and_condition: {
      before: '회원가입을 통해 ',
      link: '서비스이용약관',
      and: '과',
      privacy_policy: '개인정보보호정책',
      after: '에 동의합니다.'
    },
    sign_in_with_facebook: 'Facebook으로 로그인',
    sign_out_with_facebook: '이 기기에서 Facebook 로그아웃',
    sign_in_with_line: 'LINE으로 로그인',
    sign_in_with_weibo: 'Weibo로 로그인',
    create_account: '새 계정 만들기',
    or: '또는',
    already_have_an_account: '이미 계정을 가지고 계신가요?',
    sign_in_with_email: '이메일로 로그인',
    forgot_password: '비밀번호를 잊어버리셨나요?'
  },
  new_user: {
    information: '이름과 이메일 주소를 입력하신 후 가입하기를 눌러주세요',
    information2: 'chatbot@tripla.jp로부터 인증이메일을 보내드릴 예정입니다.',
    first_name: '이름',
    last_name: '성',
    name_placeholder: '이름',
    email_placeholder: '이메일 주소',
    submit: '가입하기',
    email_sent:
      '인증 링크를 이메일로 전송되었습니다. 해당 링크를 클릭 후 {sign in} 해주시기 바랍니다.',
    error_message: {
      problem:
        '계정 생성 중 문제가 발생했습니다. 이메일 주소를 확인 후 다시 시도해 주시기 바랍니다.',
      email: '사용이 불가한 이메일이거나 이미 사용중입니다.'
    }
  },
  new_session: {
    information: '이메일 주소와 비밀번호를 입력 후 로그인 해주세요.',
    email_placeholder: '이메일 주소',
    password_placeholder: '비밀번호',
    submit: '로그인/멤버십 등록',
    error_message: {
      email: '죄송합니다. 이메일주소 혹은 비밀번호가 잘못되었습니다.',
      known_user_different: '사용자가 다릅니다.'
    }
  },
  destroy_session: {
    information:
      '로그아웃을 원하시나요? 만약 기존 메세지를 보고 싶으시다면 다시 로그인이 필요합니다.',
    submit: '로그아웃'
  },
  forgotten_password: {
    information:
      '이메일 주소를 입력해주시기 바랍니다. 입력하신 이메일 계정으로 확인 메일을 보내드리겠습니다.',
    email_placeholder: '이메일 주소',
    submit: '보내기',
    error: '비밀번호 리셋 불가'
  },
  forgotten_password_confirmation: {
    information: '잠시 후 비밀번호 리셋 관련 이메일을 받게 되실 겁니다.'
  },
  reset_password: {
    title: '비밀번호 변경하기',
    password_title: '비밀번호',
    password_hint: '최소 8글자 이상',
    password_confirmation_title: '비밀번호 (확인)',
    submit: '비밀번호 변경하기'
  },
  set_reset_password: {
    title: '비밀번호 변경하기',
    information: '비밀번호를 재설정했습니다.',
    information2: '돌아가셔서 재설정하신 비밀번호로 다시 로그인해주시기 바랍니다.'
  },
  menu_items: {
    1: '가능한객실 검색',
    2: '객실예약',
    3: '객실예약 확인'
  },
  modal: {
    back_to_chat: '채팅화면으로 돌아가기'
  },
  gmoPaypalOptions: {
    visa: 'VISA',
    master: 'Mastercard',
    mastercard: 'Mastercard',
    amex: 'American Express',
    jcb: 'JCB',
    diners: 'Diners Club'
  },
  credit_card: {
    error: {
      cvv: 'CVV가 올바른지 확인하십시오.',
      expiration: '만료일이 올바른지 확인하십시오.',
      name: '카드 소유자의 이름이 올바른지 확인하십시오.',
      number: '유효한 신용카드 번호를 사용하십시오.',
      unknown: '요청을 처리하는 중에 문제가 발생했습니다. 입력하신 정보가 올바른지 확인하십시오.',
      reservation_month: '유효기간이 예약월 이후인 카드를 입력해주십시오.'
    },
    accept: '이용가능:',
    cvv: 'CVV',
    expiration: '만료일',
    intro: '사용하고자 하는 카드의 필요 정보를 입력해 주십시오.',
    name: '카드 소유자 이름',
    number: '카드번호',
    save: '이 카드를 저장',
    submit: '카드 추가',
    title: '새 신용카드 추가',
    security_code: '보안코드',
    card_holder_confirm: '카드 소유주 이름을 확인해 주시기 바랍니다.',
    card_holder_format_confirm: '반각 로마자로 이름을 입력해 주시기 바랍니다.',
    expiration_confirm: '카드 유효기간을 확인해 주시기 바랍니다.',
    card_cvv_confirm: '보안코를 확인해 주시기 바랍니다.',
    card_number_confirm: '카드번호를 확인해 주시기 바랍니다.',
    card_brand: '카드종류',
    select_card_brand: '카드종류를 선택'
  },
  payment: {
    total: '총합'
  },
  currencies: {
    JPY: '엔화'
  },
  chat_channels: {
    title: '채널을 선택하세요.',
    facebook: '메신저',
    web: '웹',
    line: 'LINE',
    whats_app: 'WhatsApp'
  },
  rev_requests: {
    title: '요청',
    request: '요청',
    status: '상태',
    no_data: '현재 요청하신 내용이 없습니다.',
    payment: '결제',
    customer: '고객',
    phone: '전화번호',
    people: '인원수',
    facility_name: '시설명',
    requested_day: '요청일자',
    requested_time: '요청시간',
    confirm_cancel_msg:
      '해당 요청을 취소할 것인지 확인바랍니다. 취소 완료 시 관리자에게 관련 내용을 보내드립니다. ',
    cancel_request: '요청취소',
    edit_request: '요청수정',
    keep_request: '요청유지'
  },
  requests: {
    statuses: {
      _destroyed: '삭제 완료',
      cancel_requested: '요청취소',
      cancelled: '취소',
      change_requested: '요청업데이트',
      created: '생성된',
      departure_unconfirmed: '출발일 미정',
      done: '완료',
      in_progress: '진행중',
      no_show: '노쇼',
      stopped: '중지',
      wait_listed: '대기리스트',
      waiting_detail: '대기상세내용'
    }
  },
  best_rate: '최저가',
  time_picker: {
    AM: 'AM',
    PM: 'PM'
  },
  details_page: {
    details: '상세보기'
  },
  date_range: {
    select: '투숙일자 선택',
    send: '진행하시려면 선택을 클릭해주세요""',
    no_disabled_dates: '예약불가 날짜가 포함되었습니다. 유효한 날짜 범위를 선택해 주시기 바랍니다. '
  },
  facebook: {
    email_sent:
      '이메일로 주소인증 링크를 보내드렸습니다. 이메일 주소를 인증하고 예약을 진행하기 위해 링크를 클릭해 주시기 바랍니다.',
    no_email:
      '이메일 주소를 입력해주시기 바랍니다. 예약이 확정되면 이메일로 예약확인서를 발송해 드립니다. ',
    signInFailed: '로그인에 실패했습니다. 다시 시도해 주시기 바랍니다.',
    sign_out: 'Facebook에서 로그아웃하시려면 아래의 버튼을 눌러주시기 바랍니다.'
  },
  confirm_form: {
    search: '재검색',
    update_contact: '연락처정보 업데이트'
  },
  contact_form: {
    update: '업데이트',
    submit: '제출',
    full_name: '성명(알파벳 입력)',
    family_name: '성',
    first_name: '이름',
    cc_email: '... 에게 이메일 참조',
    error: {
      full_name_error: '전체 이름을 영어로 제공해 주세요.',
      tel_format_error: '전화번호로 사용가능한 것은 숫자, 공백, ( ), - , + , 입니다.',
      tel_length_error: '전화번호는 9자리 이상을 입력해주시기 바랍니다.',
      email_format_error: '정확한 이메일 주소 입력하시기 바랍니다.（예：name@gmail.com）',
      email_confirmation_error: '이메일주소가 동일하지 않음'
    }
  },
  room_not_available:
    '죄송합니다. 찾으시는 조건으로 이용할 수 있는 객실이 없습니다.  다른 날짜로 검색해주시기 바랍니다.',
  search_again: '재검색',
  room_not_available_short: '이용불가',
  email_form: {
    note_placeholder: '요청에 관한 세부 내용을 입력해 주십시오.'
  },
  rental_car_form: {
    pickup_title: '픽업매장',
    pickup_area: '지역선택',
    pickup_shop: '매장선택',
    pickup_date_time: '픽업날짜',
    return_title: '반납매장',
    return_area: '지역 선택',
    return_shop: '매장선택',
    return_date_time: '반납일',
    back: '돌아가기'
  },
  search_area_form: {
    select_prefecture_area: '행정구역과 지역을 선택하여 주시기 바랍니다.',
    prefecture: '행정구역',
    area: '지역'
  },
  restaurant_form: {
    breakfast: '조식',
    lunch: '런치',
    dinner: '디너',
    main_time: '메인시간',
    alternative_times: '가능시간',
    pick_multiple: '최대 3개까지 중복선택 가능합니다.',
    any_available_time: '모든 가능시간을 선택'
  },
  terms_of_use: '이용규약',
  privacy_policy: '개인정보보호정책',
  browser_warning:
    '오래된 버전의 브라우저를 이용 중입니다. 최적화된 환경에서 이용하시려면 브라우저를 업데이트 해 주십시오.',
  for_night: '{n}박 요금',
  chat_icon: {
    chat: '채팅'
  },
  chat_evaluation: {
    title: '고객 만족도',
    msg: '챗봇 서비스에 만족하십니까?',
    not_satisfied: '불만족',
    satisfied: '만족'
  },
  cookie_consent: {
    title: '쿠키 동의 정책',
    necessary: '동의 필수: 채팅 기록 및 로그인 상태',
    functional:
      '기능: 해당 쿠키는 개인 정보 보호 정책 및 챗봇 레이아웃과 같은 기본 설정을 저장합니다.',
    performance:
      '퍼포먼스: 해당 쿠키는 방문 및 사용자 클릭을 계산하여 서비스를 개선하는 데 도움이 됩니다.',
    advertising: '타겟팅 및 광고: 해당 쿠키는 광고 메시지를 사용자와 더 관련성 있게 만듭니다.',
    accept_all: '모두 수락',
    confirm: '자신의 선택을 확인',
    cookies_accepted: '쿠키 허용'
  },
  ota_name: {
    agoda: 'Agoda',
    booking_com: 'Booking com',
    expedia: 'Expedia',
    jalan: 'Jalan',
    rakuten_travel: 'Rakuten Travel',
    rakutenTravel: 'Rakuten Travel'
  }
}
